import axios from 'axios';

const PAGINATION_PARAMS = {
    name: '',
    pageNumber: 0,
    resultsPerPage: 1000,
};

export const getPrintOptionsData = async () => {
    try {
        // 1. document types
        const resTypes = await axios.get('/document-types/graduation', { params: PAGINATION_PARAMS });

        const documentTypes = resTypes.data
            .map(el => ({
                ...el,
                key: el.id,
                value: el.id,
                text: el.name
            }))
            .filter(e => e.name !== 'Uvjerenje o završenom ciklusu studija');

        if (!resTypes.data.length) {
            throw new Error('No document types');
        }

        const firstTypeId = resTypes.data[0].id;

        // 2. document reasons (po prvom type-u)
        const resReasons = await axios.get('/document-reasons/get-reasons/' + firstTypeId);

        const documentReasons = resReasons.data.map(el => ({
            ...el,
            key: el.id,
            value: el.id,
            text: el.name
        }));

        // 3. languages
        const resLanguages = await axios.get('/languages');

        const languages = resLanguages.data
            .filter(e =>
                e.twoLetterCode === 'bs' ||
                e.twoLetterCode === 'hr' ||
                e.twoLetterCode === 'en'
            )
            .map(el => ({
                ...el,
                key: el.id,
                value: el.id,
                text: el.name
            }));

        return {
            documentTypes: documentTypes,
            documentReasons: documentReasons,
            languages: languages,
            defaultValues: {
                documentType: firstTypeId,
                documentReason: documentReasons[0] ? documentReasons[0].value : '',
                language: resLanguages.data[0] ? resLanguages.data[0].id : ''
            }
        };

    } catch (err) {
        console.error('Failed to fetch print options data', err);
        return {
            documentTypes: [],
            documentReasons: [],
            languages: [],
            defaultValues: {}
        };
    }
};



// WEBPACK FOOTER //
// ./src/views/StudentService/StudentOverview/PrintOptionsService.js